import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Image from './ServicesSlideImage';

import { parallax } from './utils';

import { Title, TitleTypes, FormattedMessageWithLinks, Text, TextTypes } from 'modules/ui';

const ServicesSlide = ({ styles, rules, title, titleAs, description, list, image, slideId }) => {
    const [mounted, setMounted] = React.useState(false);

    const containerRef = React.useRef(null);

    React.useEffect(() => {
        if (mounted && image) {
            const container = containerRef.current;
            // const image = imageRef.current;

            // TODO find a better way of doing this
            // not nice but better than pasing container reference
            // trough this many components
            const background = document.getElementById('services-bg');

            // Gatsby image doesnt support ref forwarding
            const image = document.getElementById(`img-${slideId}`);

            container.onmousemove = e =>
                parallax({ e, foreground: image, movement: -20, background, container: background });
        }
        setMounted(true);
        // eslint-disable-next-line
    }, [mounted]);

    return (
        <div date-event-id="carousel-slide" ref={containerRef} className={styles.container}>
            <Title extend={rules.extendTitle} as={titleAs} type={TitleTypes.H1_ITALIC_UPPERCASE}>
                <FormattedMessage id={title} />
            </Title>
            <div className={styles.textContainer}>
                <Text extend={rules.extendText} type={TextTypes.LARGE} as="p">
                    <FormattedMessageWithLinks extend={{ link: rules.link }} id={description} />
                </Text>
                {list && (
                    <ul className={styles.list}>
                        <FormattedMessage
                            id={list}
                            values={{
                                item: (...chunks) => (
                                    <li className={styles.listItem}>
                                        <h5 className={styles.listItemContainer}>{chunks}</h5>
                                    </li>
                                ),
                            }}
                        />
                    </ul>
                )}
                {image && <Image id={`img-${slideId}`} src={image.src} alt={image.alt} />}
            </div>
        </div>
    );
};

ServicesSlide.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    list: PropTypes.string,
    titleAs: PropTypes.oneOf(Object.values(TitleTypes)),
    image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    slideId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ServicesSlide.defaultProps = {
    list: null,
    titleAs: TitleTypes.H3,
    image: undefined,
};

export default ServicesSlide;
